'use client'

import { Button } from '@heroui/button'

import { GoogleIcon } from '@/components/shared/icons'
import { authClient } from '@/lib/auth-client'

const GoogleSigninButton = () => {
  const handleGoogleSignin = async () => {
    await authClient.signIn.social(
      {
        provider: 'google',
      },
      {
        onSuccess: (ctx) => {
          console.log('onSuccess', ctx.response.headers)
        },
      },
    )
  }
  return (
    <Button
      variant="faded"
      color="primary"
      size="lg"
      radius="full"
      onPress={handleGoogleSignin}
      isIconOnly={false}
      startContent={<GoogleIcon className="text-base" />}
    >
      Continue with Google
    </Button>
  )
}

export default GoogleSigninButton
